<html>

<head>
</head>

<body class="mat-dialog-container">
  <main>

    <div class="Frame">

      <div id="header">
        <h1 class="header">{{this.data.submittedData[0].street_address ||this.data.submittedData[0].subdivision_name + ' ' + this.data.submittedData[0].lot }}  HVAC Review</h1>
      </div>

      <div id="plan_name">
        <h3 class="plan_name">{{this.data.submittedData[0].hvac_dsn_descrpt.trim()}}</h3>
      </div>

      <!--First Page-->
      <div id="firstpage" style="display:block" class="page">

      <div id="hvac_form" [formGroup]="form">
      <div id="rowOne" class="rowOne">
        <div class="rowItem" style="width:55px;">
          <!--<img class="cfa-img"  src="https://rhassets.s3.amazonaws.com/bx_areagood.svg"> -->
          <svg width="50" height="50" viewBox="0 0 50 50">
            <path  [class]="getColor('cfa')" d="M6.25 10.4167V39.5833C6.25 41.8812 8.11875 43.75 10.4167 43.75H39.5833C41.8812 43.75 43.75 41.8812 43.75 39.5833V10.4167C43.75 8.11875 41.8812 6.25 39.5833 6.25H10.4167C8.11875 6.25 6.25 8.11875 6.25 10.4167ZM39.5875 39.5833H10.4167V10.4167H39.5833L39.5875 39.5833Z" fill="#44AC2A"/>
            <path  [class]="getColor('cfa')" d="M31.25 25H35.4167V14.5833H25V18.75H31.25V25ZM25 31.25H18.75V25H14.5833V35.4167H25V31.25Z" fill="#44AC2A"/>
            </svg>

          <span [class]="getColorText('cfa')" style="margin-left: 12px;">CFA
            </span>

            <!--
            <span class="cfa-txt-nums tooltip" style="margin-left: 3px;">2898<div class="right"><h4>Rater CFA: 2894</h4>Difference: 4 sq.ft </div></span>
        -->

             <span [class]="getColorText('cfa')"> <input type="text" id="cfaInput" formControlName = 'cfa'  name="cfa"  style="margin-left:-6px;width:55px;" /></span>
          </div>

        <div class="rowItem" style="width: 55px;">
          <!--<img class="cfa-img"  src="https://rhassets.s3.amazonaws.com/cil_windowgood.svg"> -->
          <svg width="50" height="50" viewBox="0 0 50 50">
            <path [class]="getColor('wa')" d="M41.4062 42.9688V4.6875H8.59375V42.9688H4.6875V46.0938H45.3125V42.9688H41.4062ZM11.7188 7.8125H23.4375V19.5312H11.7188V7.8125ZM11.7188 22.6562H23.4375V36.7188H11.7188V22.6562ZM38.2812 42.9688H11.7188V39.8438H38.2812V42.9688ZM38.2812 36.7188H26.5625V22.6562H38.2812V36.7188ZM38.2812 19.5312H26.5625V7.8125H38.2812V19.5312Z" fill="#44AC2A"/>
            </svg>
          <span [class]="getColorText('wa')" style="margin-left: 12px;">WA</span>
          <!--
          <span class="cfa-txt-nums tooltip" style="margin-left: 6px;">413
          -->

          <span [class]="getColorText('wa')"><input type="text" id="waInput" formControlName = 'wa' style="margin-left:-6px; width:50px;" />
            </span>
        </div>

        <div class="rowItem" style="width: 55px; margin-top: 10px;">
          <!--<img class="cfa-img"  src="https://rhassets.s3.amazonaws.com/fa6-solid_user-groupgood.svg"> -->
          <svg width="50" height="40" viewBox="0 0 50 40" >
            <rect width="50" height="40" fill="#424242"/>
            <path [class]="getColor('noocupants')" d="M17.5 20C23.0234 20 27.5 15.5227 27.5 10C27.5 4.47734 23.0234 0 17.5 0C11.9766 0 7.5 4.47734 7.5 10C7.5 15.5227 11.9766 20 17.5 20ZM21.4609 23.75H13.5391C6.06016 23.75 0 29.8125 0 37.2891C0 38.7891 1.2125 40 2.70781 40H32.2891C33.7891 40 35 38.7891 35 37.2891C35 29.8125 28.9375 23.75 21.4609 23.75ZM37.4297 25H31.6602C35.25 27.9453 37.5 32.3516 37.5 37.2891C37.5 38.2891 37.2031 39.2109 36.7188 40H47.5C48.8828 40 50 38.875 50 37.4297C50 30.5938 44.4062 25 37.4297 25ZM33.75 20C38.5859 20 42.5 16.0859 42.5 11.25C42.5 6.41406 38.5859 2.5 33.75 2.5C31.7883 2.5 29.9969 3.16836 28.5375 4.25859C29.4375 5.98672 30 7.92188 30 10C30 12.775 29.068 15.3234 27.532 17.3992C29.1172 19 31.3125 20 33.75 20Z" fill="#44AC2A"/>
            </svg>

          <span [class]="getColorText('noocupants')" style="margin-left: -9px;">Occupants</span>
          <span [class]="getColorText('noocupants')"> <input type="text" id="noocInput" formControlName = 'noocupants' style="margin-left: -6px;"/>
            </span>
        </div>


      </div>
      <div id="rowTwo" class="rowTwo" style="width:330px;">

        <div class="rowItem" style="width:33%">
          <!--<img class="cfa-img" style="position: relative; right: 20px;" src="https://rhassets.s3.amazonaws.com/bx_sungood.svg" > -->
          <svg width="50" height="50" viewBox="0 0 50 50" >
            <rect width="50" height="50" fill="#424242"/>
            <path [class]="getColor('shgc')" d="M14.5688 25C14.5688 30.7521 19.2479 35.4313 25 35.4313C30.7521 35.4313 35.4313 30.7521 35.4313 25C35.4313 19.2479 30.7521 14.5688 25 14.5688C19.2479 14.5688 14.5688 19.2479 14.5688 25ZM25 18.7354C28.4542 18.7354 31.2646 21.5458 31.2646 25C31.2646 28.4542 28.4542 31.2646 25 31.2646C21.5458 31.2646 18.7354 28.4542 18.7354 25C18.7354 21.5458 21.5458 18.7354 25 18.7354ZM22.9125 39.5833H27.0792V45.8333H22.9125V39.5833ZM22.9125 4.16667H27.0792V10.4167H22.9125V4.16667ZM4.16251 22.9167H10.4125V27.0833H4.16251V22.9167ZM39.5792 22.9167H45.8292V27.0833H39.5792V22.9167ZM8.78959 38.2563L13.2063 33.8354L16.1542 36.7813L11.7375 41.2021L8.78959 38.2563ZM33.8333 13.2167L38.2542 8.79583L41.2 11.7417L36.7792 16.1625L33.8333 13.2167ZM13.2125 16.1646L8.79167 11.7438L11.7396 8.79792L16.1563 13.2188L13.2125 16.1646ZM41.2 38.2583L38.2542 41.2042L33.8333 36.7833L36.7792 33.8375L41.2 38.2583Z" fill="#44AC2A"/>
            </svg>
          <span [class]="getColorText('shgc')" >SHGC</span>
          <span [class]="getColorText('shgc')"> <input type="text" id="shgcInput" formControlName="shgc" />
            </span>
        </div>

        <div class="rowItem" style="width:33%">
          <img class="cfa-img" style="left:10px; position:relative;" src="https://rhassets.s3.amazonaws.com/carbon_temperature-maxgood.svg">
          <span class='cfa-txt' style="margin-left: -25px; position: relative;left: 10px;">Temp Location</span>
          <span><input type="text" id="outdoorInput" formControlName = 'outdoortemplocation' style="margin-left: -10px; width:140px !important; position:relative; right: 35px;"/></span>
        </div>

        <div class="rowItem" style="width:33%">
          <img class="cfa-img" style="position: relative;left: 19px;" src="https://rhassets.s3.amazonaws.com/Groupgood.svg">
          <span [class]="getColorText('ventrate')" style="margin-left: -25px; position:relative; left: 40px;">Vent rate</span>
          <span [class]="getColorText('vent')"><input type="text" id="ventInput" formControlName = 'mechanicalvent' style="width: 50px; position:relative; left: 15px;"/>
             </span>
        </div>

      </div>

    </div>



      <footer>
        <button class="footerButton" (click)="navigateTo('systems');saveDesign();"><span style="color:white; margin-left: 5px;">Save and View Systems</span></button>
      </footer>

      </div>

      <!--Systems and Equipment-->
      <div id="systems" style="display:none;" class="page">

        <main>

            <!-- TAB HEADERS-->
          <div class="tab-container" style="display:flex; margin-top: 15px;">

            <!--Tab Links, use for each here-->
            <span *ngFor = "let item of data.submittedData; let in = index;" class='tab-link' [id]=' "system_" +  (in + 1)' (click)="changeSystem($event, in)">{{'System ' + (in + 1)}}</span>

          </div>


          <div class="systemDiv">
          <!-- Content will be dynamically generated here-->
          <div>
            <p class="equipText" style="text-decoration: underline;justify-content: center;">{{name}}</p>
          </div>


          <div>
            <p class='equipText' style="color:lightgreen;">{{cooling}}</p>
          </div>

          <div class="rowOne-sys" style="margin-top:20px;">

            <div class="rowItem">
              <p [class]="equipText()" style="font-size: 16px;margin-left: 30px;">{{coolpct || 0}}</p>
              <p [class]="equipText()" style="font-size: 16px">Cooling Size %</p>
            </div>

            <div class="rowItem">
              <p [class]="loadText()" style="font-size: 16px;margin-left:40%;">{{difference || 0}}</p>
              <p [class]="loadText()" style="font-size: 16px; margin-left:9%;">Load Difference</p>
            </div>


          </div>

          <div class="latent" id="latent">

            <div class="heatgains-item">
              <span><p style="width: 220px !important; display: inline-block !important;">3.11 Design Latent Heat Gain</p><input  style="width:50px !important; display: inline-block !important; color:white !important;" (input)="updateDesHeatGain()" type="text" id="desl" [value]="deslheatgain"/></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width: 220px !important; display: inline-block !important;">Capacity at Design Conditions</p><input id="totcap" (input)="updateDifference()"  style="width:50px !important; display: inline-block !important; color:white !important;"  type="text" id="totcap" [value]="totaldescap"/></span>
            </div>

          </div>

          <div class="heatgains">


            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important;">N</p><input (input)="updateIndividualHeatGain('ndsn', 1)" style="width:50px !important; display: inline-block !important;" type="text" id="ndsn" [value]="dessheatgainn"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgainn}}</p></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important;">E</p><input (input)="updateIndividualHeatGain('edsn', 1)" style="width:50px !important; display: inline-block !important;" type="text" id="edsn" [value]="dessheatgaine"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgaine}}</p></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important;">S</p><input (input)="updateIndividualHeatGain('sdsn', 1)" style="width:50px !important; display: inline-block !important;" type="text" id="sdsn" [value]="dessheatgains"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgains}}</p></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important;">W</p><input (input)="updateIndividualHeatGain('wdsn', 1)" style="width:50px !important; display: inline-block !important;" type="text" id="wdsn" [value]="dessheatgainw"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgainw}}</p></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important; padding-right: 30px;">NE</p><input (input)="updateIndividualHeatGain('nedsn', 2)" style="width:50px !important; display: inline-block !important;" type="text" id="nedsn" [value]="dessheatgainne"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgainne}}</p></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important; padding-right: 30px;">SE</p><input (input)="updateIndividualHeatGain('sedsn', 2)" style="width:50px !important; display: inline-block !important;" type="text" id="sedsn" [value]="dessheatgainse"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgainse}}</p></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important; padding-right: 30px;">SW</p><input (input)="updateIndividualHeatGain('swdsn', 2)" style="width:50px !important; display: inline-block !important;" type="text" id="swdsn" [value]="dessheatgainsw"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgainsw}}</p></span>
            </div>

            <div class="heatgains-item">
              <span><p style="width:20px !important; display: inline-block !important; padding-right: 30px;">NW</p><input (input)="updateIndividualHeatGain('nwdsn', 2)" style="width:50px !important; display: inline-block !important;" type="text" id="nwdsn" [value]="dessheatgainnw"/> <p  style="color:#44AC2A; margin-left: 15px;width:50px !important; display: inline-block !important;">{{destotlheatgainnw}}</p></span>
            </div>

          </div>


          <div class="rowTwo-sys" style="width:90%">

            <div style="width:330px;">
              <p class="model-num-txt" style="display: inline-block; padding-right: 30px;"><span style="width:50%;display: inline-block;">Condenser</span></p> <span style="width:50%; display: inline-block;"><input type="text" id="condensermnInput" style="width: 200px !important; color:white !important;" [value]="condenser"/></span>
              <p class="model-num-txt" style="display: inline-block; padding-right: 30px;"><span style="width:50%;display: inline-block;">Evaporator</span></p> <span style="width:50%; display: inline-block;"><input type="text" id="evaporatorInput" style="width: 200px !important; color:white !important;" [value]="evaporator"/></span>
              <p class="model-num-txt" style="display: inline-block; padding-right: 30px;"><span style="width:50%;display: inline-block;">Furnace</span></p> <span style="width:50%; display: inline-block;"><input type="text" id="furnaceInput" style="width: 200px !important; color:white !important;" [value]="furnace"/></span>
              <!--
              <p class="model-num-txt"><span style="width:50%;">Evaporator </span> <span style="width:50%;">{{evaporator}}</span></p>
              <p class="model-num-txt"><span style="width:50%;">Furnace </span> <span style="width:50%;">{{furnace}}</span></p>
              -->
            </div>

            <div>
                <button class="saveButtonSystems" (click) = "saveSystemAndEquipment(currSystem)" style="margin-bottom:60px;"><span style="color:white; margin-left: 25px;">Save this System</span></button>
            </div>

          </div>

          </div>

        </main>

      <footer>
        <img class="backButton" src="https://rhassets.s3.amazonaws.com/bx_arrow-backunclicked.svg" (click)="navigateTo('firstpage')">
        <button class="footerButton footerButton-Systems" (click)="dialogRef.close(1)"><span style="color:white; margin-left: 55px;">Re-submit</span></button>
      </footer>
      </div>

      <div id="lastPage" style="display:none;" class="page">
        <main>
          <label class="container">Errors Present?<input type="checkbox" id="errorCheck" (change)="true" #errorCheck ><span class="checkmark"></span> </label>
          <label class="container" style="margin-top:100px;">Complete?<input type="checkbox" id="completeCheck" (change)="true" #completeCheck><span class="checkmark"></span> </label>
        </main>

        <div *ngIf="errorCheck.checked"  style="color:white">
          <textarea class="notes-txt" id="emailnotes" placeholder="Enter notes for contractor"></textarea>
          <p class="emailTxt">This email will go to: {{designeremail}}</p>
          <button class="footerButton footerButton-Systems"><span style="color:white; margin-left: 27px;">Complete Review</span></button>

        </div>

        <div *ngIf="completeCheck.checked">
          <button class="footerButton footerButton-Systems" ><span style="color:white; margin-left: 27px;">Complete Review</span></button>
        </div>

        <footer>
          <img class="backButton" src="https://rhassets.s3.amazonaws.com/bx_arrow-backunclicked.svg" (click)="navigateTo('systems')">
        </footer>

      </div>

    </div>



  </main>
</body>

</html>

